import { render } from "./DatadogCase.vue?vue&type=template&id=054580d1&scoped=true"
import script from "./DatadogCase.vue?vue&type=script&lang=js"
export * from "./DatadogCase.vue?vue&type=script&lang=js"

import "./DatadogCase.vue?vue&type=style&index=0&id=054580d1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054580d1"]])

export default __exports__